import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface AIUsageState {
  usageCount: number
  lastResetDate: string
  incrementUsage: () => void
  resetUsage: () => void
  canUseAI: () => boolean
  getRemainingUsage: () => number
}

const MAX_USAGE_FOR_GUESTS = 3

export const useAIUsageStore = create<AIUsageState>()(
  persist(
    (set, get) => ({
      usageCount: 0,
      lastResetDate: new Date().toDateString(),

      incrementUsage: () => {
        const { lastResetDate } = get()
        const today = new Date().toDateString()
        
        // 如果是新的一天，重置使用次数
        if (lastResetDate !== today) {
          set({ usageCount: 1, lastResetDate: today })
        } else {
          set((state) => ({ usageCount: state.usageCount + 1 }))
        }
      },

      resetUsage: () => {
        set({ usageCount: 0, lastResetDate: new Date().toDateString() })
      },

      canUseAI: () => {
        const { usageCount } = get()
        return usageCount < MAX_USAGE_FOR_GUESTS
      },

      getRemainingUsage: () => {
        const { usageCount } = get()
        return Math.max(0, MAX_USAGE_FOR_GUESTS - usageCount)
      },
    }),
    {
      name: 'ai-usage-storage',
      partialize: (state) => ({
        usageCount: state.usageCount,
        lastResetDate: state.lastResetDate,
      }),
    }
  )
) 